export default "__VITE_ASSET__BMjJRJjt__"